import { TRootState } from "../store/create-store";
import { TLinearRegression, TLogitRegression } from "../types/worker";
import { TPCA } from "../types";

const selectWorkerSlice = (state: TRootState) => state.worker;

export const selectLinearRegression = (
  state: TRootState,
  key: string
): TLinearRegression | undefined =>
  selectWorkerSlice(state).cache.linearRegression[key];

export const selectLogisticRegression = (
  state: TRootState,
  cacheKey: string
): TLogitRegression | undefined =>
  selectWorkerSlice(state).cache.logisticRegression[cacheKey];

export const selectPCAForCacheKey = (
  state: TRootState,
  cacheKey: string
): TPCA | undefined => selectWorkerSlice(state).cache.pca[cacheKey];

export const selectSilhouetteScoreForCacheKey = (
  state: TRootState,
  cacheKey: string
): number | undefined =>
  selectWorkerSlice(state).cache.silhouetteScore[cacheKey];

export const selectWorkers = (state: TRootState) =>
  selectWorkerSlice(state).workers;

export const selectCorrelations = (state: TRootState, cacheKey: string) =>
  selectWorkerSlice(state).cache.correlations[cacheKey];

export const selectAreAllWorkersIdle = (state: TRootState) =>
  Object.values(selectWorkerSlice(state).workers).every(
    (worker) => worker.state === "idle"
  );

export const isAnyWorkerIdle = (state: TRootState) =>
  Object.values(selectWorkerSlice(state).workers).some(
    (worker) => worker.state === "idle"
  );
